<template>
  <!-- 素材上传  -->
  <div class="Materialtoupload">
    <div
      class="Materiaupload"
      v-if="this.$store.state.user.status === '已通过' && wdscxx == '素材上传'"
    >
      <div class="altk" @click="uploadmaterial('素材上传')">
        <i class="iconfont gos-shangchuan1"></i>
      </div>
      <span @click="uploadmaterial('素材上传')"> 素材上传</span>
    </div>
    <div
      class="Materiaupload"
      v-if="
        this.$store.state.user.status === '已通过' &&
        wdscxx == '科普/论文上传' &&
        this.$store.state.usert.dentity.includes('医生')
      "
    >
      <div class="altk" @click="uploadmaterial('科普/论文上传')">
        <i class="iconfont gos-shangchuan1"></i>
      </div>
      <span @click="uploadmaterial('科普/论文上传')"> 科普/论文上传</span>
    </div>
    <div
      class="Materiaupload"
      v-if="this.$store.state.user.status === '已通过' && wdscxx == '课程上传'"
    >
      <div class="altk" @click="uploadmaterial('课程上传')">
        <i class="iconfont gos-shangchuan1"></i>
      </div>
      <span @click="uploadmaterial('课程上传')"> 课程上传</span>
    </div>
    <div class="box">
      <div class="tbox-top">
        <h4 class="scsc">我的上传</h4>
        <el-menu
          :default-active="wdscxx"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item
            :style="{ color: wdscxx == '课程上传' ? ' #4CCAFF' : '#000' }"
            index="课程上传"
            >课程上传</el-menu-item
          >
          <el-menu-item
            v-if="this.$store.state.usert.dentity.includes('医生')"
            :style="{ color: wdscxx == '科普/论文上传' ? ' #4CCAFF' : '#000' }"
            index="科普/论文上传"
            >科普/论文上传</el-menu-item
          >
          <el-menu-item
            :style="{ color: wdscxx == '素材上传' ? ' #4CCAFF' : '#000' }"
            index="素材上传"
            >素材上传</el-menu-item
          >
        </el-menu>
      </div>
      <Courselist v-if="wdscxx == '课程上传'"></Courselist>
      <MaterialList v-if="wdscxx == '素材上传'"></MaterialList>
      <KPList v-if="wdscxx == '科普/论文上传'"></KPList>
    </div>
  </div>
</template>
<script>
import {
  selusersc,
  selsort,
  delmaterial,
  updmaterialsp,
  updmaterial,
} from "../../../api/patient";
import Courselist from "../Courselist/Courselist.vue";
import MaterialList from "./MaterialtoList.vue";
import KPList from "./KPList.vue";
export default {
  components: {
    Courselist,
    MaterialList,
    KPList,
  },
  data() {
    return {
      wdscxx: "课程上传",
      chehuiyuassnyin: false,
      chehuiyuanyin: false,
      chehid: "",
      http: this.$store.state.https,
      name: "",
      tepage: {
        page: 1,
        rows: 9,
        total: 100,
      },
      Majorcategories: "",
      value: "全部",
      options: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "已保存",
          label: "已保存",
        },
        {
          value: "审批中",
          label: "审批中",
        },
        {
          value: "已通过",
          label: "已通过",
        },
        {
          value: "驳回",
          label: "已驳回",
        },
        {
          value: "已撤回",
          label: "已撤回",
        },
      ],
      formInline: [],
      rules: {},
      dialogVisiblebh: false,
      bhyys: "",
      textarssea: "",
    };
  },
  created() {
    this.wdscxx = this.$store.state.wdsc;
  },
  methods: {
    // 导航栏切换
    handleSelect(val) {
      this.$store.commit("wdsc", val);
      this.wdscxx = this.$store.state.wdsc;
    },
    chehuisyuanyin(item) {
      this.chehuiyuanyin = true;
      this.chehid = item.id;
    },
    chehuizhua() {
      if (this.textarssea !== "" && this.textarssea !== null) {
        var datas = new FormData();
        datas.append("ids", this.chehid);
        datas.append("status", "已撤回");
        datas.append("bhyy", this.textarssea);
        updmaterialsp(datas).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.chehuiyuanyin = false;
            this.selmaterialis();
          }
        });
      } else {
        this.$message({
          message: "请填写完整",
          type: "warning",
        });
      }
    },
    uploadmaterial(type) {
      if (this.$store.state.isLogin) {
        if (type == "素材上传") {
          this.$router.push("/Uploadpagem");
        }
        if (type == "课程上传") {
          this.$router.push("/Courseupload");
        }
        if (type == "科普/论文上传") {
          this.$router.push("/UploadPopular");
        }
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    handleClose() {
      this.dialogVisiblebh = false;
      this.bhyys = "";
    },
    smdpsoap(item) {
      this.chehuiyuanyin = true;
      this.textarssea = item.bhyy;
    },
    dialogVisiblebhss(item) {
      this.dialogVisiblebh = true;
      this.bhyys = item.bhyy;
    },
    // 上传全部
    async Alltheupload() {
      var isss = 0;
      const set = []; // set 自带去重
      for (let s = 0; s < this.formInline.length; s++) {
        if (this.formInline[s].status === "已保存") {
          var datas = new FormData();
          datas.append("id", this.formInline[s].id);
          datas.append("scwj", this.formInline[s].scwj);
          datas.append("scmc", this.formInline[s].scmc);
          datas.append("scgs", this.formInline[s].scgs);
          datas.append("sccc", this.formInline[s].sccc);
          datas.append("wjgs", this.formInline[s].wjgs);
          datas.append("sort", this.formInline[s].sort);
          await updmaterial(datas).then((res) => {});
          if (!set.includes(this.formInline[s].id)) {
            set.push(this.formInline[s].id);
          }
        }
      }
      for (let l = 0; l < this.formInline.length; l++) {
        if (
          this.formInline[l].sort === "" ||
          this.formInline[l].sort === null ||
          this.formInline[l].scmc === "" ||
          this.formInline[l].scmc === null
        ) {
          isss++;
          this.$message({
            showClose: true,
            message: "请填写完整",
            type: "warning",
          });
          return;
        }
      }
      if (isss === 0) {
        var data = new FormData();
        data.append("ids", set);
        data.append("status", "审批中");
        await updmaterialsp(data).then((res) => {
          console.log(res);
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: "上传成功",
              type: "success",
            });
            this.selmaterialis();
          }
        });
      }
    },
    // 跳转
    jump(item) {
      this.$router.push("/materialdetailspage");
      this.$store.commit("sucaixingqi", item.id);
    },
    // 文件保存
    submitForm(iten) {
      if (iten.scmc) {
        if (iten.sort) {
          var data = new FormData();
          data.append("id", iten.id);
          data.append("scwj", iten.scwj);
          data.append("scmc", iten.scmc);
          data.append("scgs", iten.scgs);
          data.append("sccc", iten.sccc);
          data.append("wjgs", iten.wjgs);
          data.append("sort", iten.sort);
          updmaterial(data).then((res) => {
            console.log(res);
            if (res.code === "OK") {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }

            this.selmaterialis();
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    // 文件保存
    sssubmitForm(iten) {
      if (iten.scmc) {
        if (iten.sort) {
          var data = new FormData();
          data.append("id", iten.id);
          data.append("scwj", iten.scwj);
          data.append("scmc", iten.scmc);
          data.append("scgs", iten.scgs);
          data.append("sccc", iten.sccc);
          data.append("wjgs", iten.wjgs);
          data.append("sort", iten.sort);
          updmaterial(data).then((res) => {
            console.log(res);
            if (res.code === "OK") {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            this.Fileuploadsss(iten);
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    async Fileuploadsss(item) {
      if (item.scmc) {
        if (item.sort) {
          var data = new FormData();
          data.append("ids", item.id);
          data.append("status", "已保存");
          await updmaterialsp(data).then((res) => {
            console.log(res);
            if (res.code === "OK") {
              this.selmaterialis();
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    // 文件上传
    async Fileupload(item) {
      if (item.scmc) {
        if (item.sort) {
          var data = new FormData();
          data.append("id", item.id);
          data.append("scwj", item.scwj);
          data.append("scmc", item.scmc);
          data.append("scgs", item.scgs);
          data.append("sccc", item.sccc);
          data.append("wjgs", item.wjgs);
          data.append("sort", item.sort);
          await updmaterial(data).then((res) => {});
          var datas = new FormData();
          datas.append("ids", item.id);
          datas.append("status", "审批中");
          await updmaterialsp(datas).then((res) => {
            if (res.code === "OK") {
              this.$message({
                showClose: true,
                message: "上传成功",
                type: "success",
              });
              this.selmaterialis();
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    // 全部删除
    delmatess() {
      const set = []; // set 自带去重
      for (let s = 0; s < this.formInline.length; s++) {
        if (!set.includes(this.formInline[s].id)) {
          set.push(this.formInline[s].id);
        }
      }
      console.log(set);
      var data = new FormData();
      data.append("ids", set);
      delmaterial(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selmaterialis();
        }
      });
    },
    // 删除
    delmaterial(item) {
      var data = new FormData();
      data.append("ids", item.id);
      delmaterial(data).then((res) => {
        console.log(res);
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selmaterialis();
        }
      });
    },
    // 筛选大类
    selsortis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      selsort(data).then((res) => {
        this.Majorcategories = res.rows;
      });
    },
    // 列表
    selmaterialis() {
      var data = new FormData();
      data.append("page", this.tepage.page);
      data.append("rows", this.tepage.rows);
      data.append("id", this.$store.state.user.id);
      if (this.name) {
        data.append("name", this.name);
      }
      if (this.value === "全部") {
      } else {
        data.append("status", this.value);
      }
      selusersc(data).then((res) => {
        console.log(res);
        this.formInline = res.rows;
        this.tepage.total = res.total;
        for (let i = 0; i < this.formInline.length; i++) {
          var a = this.formInline[i].statustime.split(" ");
          this.formInline[i].statustime = a[0];
        }
      });
    },
    handleCurrentChangess(val) {
      this.tepage.page = val;
      this.selmaterialis();
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.Materialtoupload {
  .box {
    min-height: 725px;
    .tbox-top {
      display: flex;
      margin-top: 29px;
      height: 50px;

      .scsc {
        text-align: left;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }

      h2 {
        line-height: 40px;
        //   margin-right: 16px;
      }

      .el-select {
        line-height: 40px;
        width: 100px;

        ::v-deep .el-input__inner {
          border: 1px solid #5ccbff;
          height: 30px;
        }
      }

      .el-menu-demo {
        padding: 0;
        height: 30px;
        width: 40px;
        margin-left: 30px;
        line-height: 40px;
        border: 0px;
        display: flex;

        .el-menu-item {
          margin-left: 20px;
          padding: 0 5px;

          height: 30px;
          line-height: 24px;
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          // color: #4CCAFF;
        }
        ::v-deep.is-active {
          border-bottom: 2px solid #4ccaff;
        }
      }
    }

    .scscxsk {
      cursor: pointer;
      display: flex;
      margin-bottom: 10px;
    }
  }
}

.searchbox {
  line-height: 40px;

  width: 255px;

  ::v-deep .el-input__inner {
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    // border-top-right-radius: 15px;
    // border-bottom-right-radius: 15px;
  }

  ::v-deep .el-input-group__append {
    margin-left: 100px;
    // line-height: 30px;
    border: 0px;
    background: #fff;

    .el-button {
      position: relative;
      left: -10px;
      top: -1px;
      padding: 0px;
      width: 70px;
      height: 30px;
      background: #4ccaff;
      border: 1px solid #ededed;
      border-radius: 15px;
      color: #fff;
    }
  }
}

.deleta {
  line-height: 20px;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fb4747;
  cursor: pointer;
}

.scscxsk {
  text-align: left;
  width: 770px;
  height: 151px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  transition: all 0.2s;

  video {
    width: 268px;
    height: 151px;

    opacity: 0.9;
    border-radius: 6px;
    line-height: 151px;
  }

  img {
    width: 268px;
    height: 151px;
    opacity: 0.8;
    border-radius: 6px;
  }

  .certer {
    padding: 0 20px;
  }
}

.scscxsk:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
}

.right-bottom {
  display: flex;
  flex-direction: column;
  width: 76px;
  padding-right: 20px;

  button {
    margin: 0px;
    padding: 0;
    width: 76px;
    height: 28px;
    border-radius: 6px;
    border: 0;
  }

  .lasez {
    background: #4ccaff;
  }

  .lasez:hover {
    background: #4ccaffc9;
  }

  .sch:hover {
    background: #f56c6cc7;
  }
}

ul {
  padding-bottom: 50px;
}

.boytrtr {
  text-align: center;

  .el-button {
    padding: 0;
    width: 99px;
    height: 28px;
    background: #4ccaff;
    border-radius: 6px;
    border: 0px;
  }
}

.el-button:hover {
  background: #4ccaffc9;
}

.demo-form-s {
  width: 403px;
  margin-left: 16px;
  margin-right: 8px;
  margin-top: 18px;

  .el-form-item {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ff1818;
    // line-height: 44px;
  }
}

.smis {
  text-align: center;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  // line-height: 44px;
}

ul {
  min-height: 700px;
}

.paging {
  margin-bottom: 70px;
}

.sadda {
  margin: 20% 0px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  text-align: center;
}

.saddsa {
  // 通过

  color: #00c92f;
}

.saddsa1 {
  // 审批

  color: #4ccaff;
}

.saddsa2 {
  // 保存

  color: #666666;
}

.saddsa3 {
  // 驳回

  color: #fb4747;
}

.ssssc {
  line-height: 20px;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 30px;
}

.el-button:hover {
  background: #4ccaffc9;
}

.el-pagination {
  ::v-deep button {
    padding: 0 5px;
  }
}

.dialogbhuyuan {
  text-align: left;

  p {
    padding-left: 20px;
  }
}

.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}

img {
  object-fit: contain;
}

.Materiaupload {
  position: fixed;
  top: 15.6rem;
  right: 11.2rem;

  span {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #4ccaff;
  }
}

.altk {
  width: 48px;
  height: 48px;
  background: #4ccaff;
  border-radius: 6px;
  text-align: center;
  line-height: 48px;
  margin-bottom: 8px;

  .iconfont {
    font-size: 28px;
    color: #fff;
  }
}
// 适配手机端
@media (max-width: 768px) {
  .Materialtoupload {
    margin-left: 10px;
    .box {
      .tbox-top {
        display: block;
        height: 80px;
      }
    }
  }
  ul {
    min-height: 0;
  }
  .Materiaupload {
    position: fixed;
    top: 15.6rem;
    right: 2rem;
    z-index: 100;

    span {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #4ccaff;
    }
  }
}
</style>
